import { lazy } from 'react';
// Keys are the same as the module keys in the manifest.json
const modules = {
    'main-page': lazy(() => import('../pages/MainPage')),
    'admin-page': lazy(() => import('../pages/AdminPage')),
    'configuration-page': lazy(() => import('../pages/ConfigurationPage')),
    'get-started-page': lazy(() => import('../pages/GetStartedPage')),
    'jsm-detail-panel': lazy(() => import('../panels/JsmDetailPanel')),
    'jsm-creation-panel': lazy(() => import('../panels/JsmCreationPanel')),
    'activity-tab': lazy(() => import('../panels/ActivityTab'))
};
export function getModule(moduleKey) {
    if (modules[moduleKey]) {
        return modules[moduleKey];
    }
    return null;
}
